// SocketHandler.js
// Ported from Swift (iOS) to JavaScript for React.js
// Requires: npm install socket.io-client

import { io } from 'socket.io-client';

// Connection states similar to SocketWebStatus
export const SocketWebStatus = {
  CONNECTED: 'connected',
  CONNECTING: 'connecting',
  DISCONNECTED: 'disconnected',
  NOT_CONNECTED: 'notConnected',
  SOCKET_URL: 'https://broker-socket.codiantdev.com/',
};

class SocketHandler {
  static instance = null;

  static getInstance() {
    if (!SocketHandler.instance) {
      SocketHandler.instance = new SocketHandler();
    }
    return SocketHandler.instance;
  }

  constructor() {
    this.socket = null;
    this.state = SocketWebStatus.DISCONNECTED;
    this.connectionStateHandler = null;
    this.isPlayersFetched = false;
    this.hardwares = [];
  }

  connect() {
    if (this.socket) return;
    this.socket = io(SocketWebStatus.SOCKET_URL, {
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 5000,
      forceNew: true,
      secure: true,
    });
    this.state = SocketWebStatus.CONNECTING;
    this._setupListeners();
  }

  disconnect() {
    if (!this.socket) return;
    this.socket.disconnect();
    this.socket = null;
    this.state = SocketWebStatus.DISCONNECTED;
    this.isPlayersFetched = false;
    this.hardwares = [];
    if (this.connectionStateHandler) {
      this.connectionStateHandler(this.state);
    }
  }

  broadcast(data) {
    if (!this.socket || this.state !== SocketWebStatus.CONNECTED) {
      console.error('Tried to emit when socket is not connected');
      return;
    }
    console.debug('socket emit params start', data);
    this.socket.emit('send_command', data);
    console.debug('socket emit params end');
  }

  sendHardwareRequest(isPrivateMode = false) {
    if (isPrivateMode) {
      console.error('Tried to emit in private mode');
      return;
    }
    if (this.socket) {
      this.socket.emit('broker_join', { id: '0', players: this.hardwares });
    }
  }

  setConnectionStateHandler(handler) {
    this.connectionStateHandler = handler;
  }

  connectionStateLabel() {
    switch (this.state) {
      case SocketWebStatus.CONNECTED:
        return 'Connected';
      case SocketWebStatus.CONNECTING:
        return 'Connecting';
      case SocketWebStatus.DISCONNECTED:
      case SocketWebStatus.NOT_CONNECTED:
      default:
        return 'Disconnected';
    }
  }

  connectionStateColor() {
    switch (this.state) {
      case SocketWebStatus.CONNECTED:
        return 'green';
      case SocketWebStatus.CONNECTING:
        return 'yellow';
      case SocketWebStatus.DISCONNECTED:
      case SocketWebStatus.NOT_CONNECTED:
      default:
        return 'red';
    }
  }

  _setupListeners() {
    if (!this.socket) return;
    this.socket.on('connect', () => {
      this.state = SocketWebStatus.CONNECTED;
      if (this.connectionStateHandler) this.connectionStateHandler(this.state);
      this.sendHardwareRequest();
      console.debug('socket connect');
    });
    this.socket.on('disconnect', () => {
      this.state = SocketWebStatus.DISCONNECTED;
      if (this.connectionStateHandler) this.connectionStateHandler(this.state);
      console.debug('socket disconnect');
    });
    this.socket.on('connect_error', (error) => {
      this.state = SocketWebStatus.DISCONNECTED;
      if (this.connectionStateHandler) this.connectionStateHandler(this.state);
      console.error('error in socket:', error);
    });
    this.socket.on('reconnect_attempt', () => {
      this.state = SocketWebStatus.CONNECTING;
      if (this.connectionStateHandler) this.connectionStateHandler(this.state);
      console.debug('socket reconnecting');
    });
    // Add more event listeners as needed
  }
}

export default SocketHandler;

